export default {"src":"/_next/static/media/HomeProcessLight.69078036.svg","height":434,"width":572};